import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export var InvalidScopeError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidScopeError, _Error);

  var _super = _createSuper(InvalidScopeError);

  function InvalidScopeError(token) {
    _classCallCheck(this, InvalidScopeError);

    var name = typeof token === 'function' ? token.name : token.toString();
    return _super.call(this, "".concat(name, " is marked as a scoped provider. Transient scoped providers can't be used in combination with \"get()\" method. Please, use \"resolve()\" instead."));
  }

  return InvalidScopeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));